module.exports = __webpack_public_path__ + "static/media/jpeg-demo.8eee1fb7.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/ep5/jpeg-demo.jpg
 ** module id = 227
 ** module chunks = 0
 **/